<template>
    <v-dialog
        class="logout-dialog--custom"
        v-model="isShow"
        :persistent="true"
        width="auto"
    >
        <template v-slot:activator="{ props }">
            <v-btn icon="mdi-logout" @click="isShow = true"></v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 ps-5 pt-3">
                Xác nhận đăng xuất
            </v-card-title>
            <v-card-text class="logout-message">
                Bạn có chắc muốn đăng xuất không?
                <br>
                khi đăng xuất sẽ cần phải đăng nhập lại để tiếp tục sử dụng
            </v-card-text>
            <v-card-actions class="logout-action pe-4 pb-4">
                <v-spacer></v-spacer>
                <v-btn
                    class="me-3"
                    variant="text"
                    @click="isShow = false"
                >
                    Hủy
                </v-btn>
                <v-btn
                    color="red"
                    variant="flat"
                    @click="handleLogout"
                >
                    Đăng xuất
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'LogoutButtonComponent',
    data() {
        return {
            isShow: false,
        }
    },
    methods: {
        handleLogout() {
            this.isShow = false

            this.$store.dispatch('loading/show')

            this.$store.dispatch('user/logout')
                .then(() => {
                    this.$router.push({ name: 'auth.login' })
                    this.$store.dispatch('toast/show', { message: 'Đã đăng xuất' })
                })
                .catch(() => {
                    this.$store.dispatch('toast/show', {
                        message: 'Đã xảy ra lỗi, vui lòng thử lại',
                        type: 'error',
                    })
                })
                .finally(() => this.$store.dispatch('loading/hide'))
        },
    },
}
</script>
